import { WidgetComponent } from "../widget.component";
import { Component, ContentChild, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { SpinnerComponent } from "../../../elements/spinner/spinner.component";
import { FormsModule } from "@angular/forms";
import { NgTemplateOutlet } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "my-widget-config",
    templateUrl: "config-screen.widget.component.html",
    styleUrls: ["config-screen.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, FormsModule, NgTemplateOutlet, TranslatePipe]
})
export class ConfigScreenWidgetComponent {
    @Input() widgetComponent: WidgetComponent;
    @Input() addTitle: string;
    @Input() editTitle: string;
    @ContentChild(TemplateRef, { static: false }) widgetParamsTemplate: TemplateRef<any>;
}
